import { useState, useMemo, useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { Button } from '@design-systems/canvas-ui'
import Icon, { HuddleIcon } from '@design-systems/react-icons'
import './chatbot.scss'
import Chatbot from './Chatbot'

export const ChatBotWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { session, isAuthenticated } = useAuth()
  const { accessToken, userInfo } = session ?? {}

  const cookieExpirationTime = useMemo(() => {
    return new Date(userInfo?.expires * 1000).toUTCString()
  }, [userInfo?.expires])

  useEffect(() => {
    if (isAuthenticated()) {
      document.cookie = `accessToken=${accessToken}; Domain=target.com; Path=/; SameSite=None; Secure; Expires=${cookieExpirationTime}`
    }
  }, [isAuthenticated, cookieExpirationTime, accessToken])

  const onQuickHelpClick = () => {
    setIsOpen(true)
  }

  return (
    <>
      {isOpen ? (
        <Chatbot setIsOpen={setIsOpen} />
      ) : (
        <div className="button-container">
          <Button
            id="clickToChat"
            className="chat-button"
            aria-label="chat-button"
            onClick={onQuickHelpClick}
          >
            <Icon svg={HuddleIcon} size="xl" />
          </Button>
        </div>
      )}
    </>
  )
}

export default ChatBotWidget
